module.exports = __webpack_public_path__ + "media/images/return-pets-a0e9ab026338d13cf6e4a3172bc90a7d.png";